// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixLocation from 'wix-location';

$w.onReady(function () {
   let path = wixLocation.path[0];     
   let prevPath = $w("#tbPath").text;
    $w("#tbPathPrev").text = prevPath;  
    $w("#tbPath").text = path;
    console.log("path = " +path)
});